export const courseDetails = {
    redversity: {
        UG: {
            programDetails: {
                program: "UG Programmes",
                specialization: ["Diploma in Emergency Medical Technology", "BBA in Healthcare Management"]

            }
        },
        PG: {
            programDetails: {
                program: "PG Programmes",
                specialization: ["Master of Advanced Care Paramedic", "MBA in Healthcare Management"]
            },
        }
    }

}
